import React from 'react';
import Datepicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import * as moment from 'moment';
import PunishedApi from "../../api/Punished";
import { toast } from "react-toastify";
import { imgUrl } from '../../constants';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './Punished.css';

export default class PunishedForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            selected: {
                name: "",
                player_id: '',
                startDate: moment(),
                endDate: moment(),
                img: null,
                dorsal: '',
                status: '',
                default_image: ''
            },
            selectedOption: [],
            players: []
        };
    }

    componentWillMount(){
        let pr = {...this.props}
        if(pr.selected==null){
            pr = {...this.state}
        }
        pr.selected.default_image = pr.selected.img
        pr.selected.startDate = pr.selected.start_date
        pr.selected.endDate = pr.selected.end_date
        pr.players = this.getOptions({...this.props.players})
        let st = {...this.state}
        st.selectedOption.label = pr.selected.name
        st.selectedOption.value = pr.selected.id
        this.setState(st);
        this.setState(pr);
    }

    getOptions = (input) => {
        var obj = input
        var arr = [];
        for (var key in obj) {
            arr.push({"label": obj[key]["name"]+" -- "+ obj[key]["team"],"value":obj[key]["id"]});
        }
        return arr;
    }

    onStartDateChange(newDate){
        let state = {...this.state};
        state.selected.startDate = newDate;
        this.setState(state);
    }

    onEndDateChange(newDate){
        let state = {...this.state};
        state.selected.endDate = newDate;
        this.setState(state);
    }

    cancel(){
        let st =this.state;
        st.showModal = false;
        this.setState(st);
    }

    handleKeyPress(e){
        if (e.key === 'Enter') {
            this.props.save(this.state.selected)
        }
    }

    handleChange = (selectedOption) => {
        let st = {...this.state}
        st.selected.player_id = selectedOption.value
        st.selected.name = selectedOption.label
        this.setState(st)
        this.setState({ selectedOption });
    }

    render(){
        return(
            <div className="columns">
                <div className="column is-2">
                    {this.state.selected.default_image && 
                        <img src={imgUrl+this.state.selected.default_image} width="100" height="100"/>
                    }
                </div>
                <div className="column is-10">
                    <div className="FieldHorizontal field is-horizontal">
                        <div className="field-label">
                            <label className="label">Jugador</label>
                        </div>
                        <div className="field-body">
                            <Select
                                options={this.state.players}
                                name="form-field-name"
                                value={this.state.selectedOption }
                                onChange={this.handleChange}
                                placeholder="Jugador"
                            />
                        </div>
                    </div>
                    <div className="FieldHorizontal field is-horizontal">
                        <div className="field-label">
                            <label className="label">Fecha inicial</label>
                        </div>
                        <div className="field-body">
                            <Datepicker
                                selected={this.state.selected? moment(this.state.selected.startDate) : moment()}
                                onChange={(date) => this.onStartDateChange(date)}
                                showMonthDropdown
                                showYearDropdown
                                className="input"
                                placeholderText="DD/MM/YYYY"
                            />
                        </div>
                    </div>
                    <div className="FieldHorizontal field is-horizontal">
                        <div className="field-label">
                            <label className="label">Fecha final</label>
                        </div>
                        <div className="field-body">
                            <Datepicker
                                selected={moment(this.state.selected && this.state.selected.endDate)}
                                onChange={(date) => this.onEndDateChange(date)}
                                showMonthDropdown
                                showYearDropdown
                                className="input"
                                placeholderText="DD/MM/YYYY"
                            />
                        </div>
                    </div>
                    <div className="columns has-text-right buttons-modal">
                        <div className="column">
                            <button className="button is-success" onClick={() => this.props.save(this.state.selected)}>Guardar</button>
                            <button className="button" onClick={() => this.cancel()}>Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/punished/form.js